import classnames from 'classnames';
import React from 'react';

export type BadgeType =
	| 'neutral'
	| 'light'
	| 'progress'
	| 'upgrade'
	| 'info'
	| 'warning'
	| 'active'
	| 'assisted';

export type BadgeStyle = 'outline' | 'solid';
export type BadgeSize = 'condensed' | 'standard' | 'expanded';

export interface BadgeProps {
	value: React.ReactNode;
	type?: BadgeType;
	badgeStyle?: BadgeStyle;
	size?: BadgeSize;
	leftIcon?: React.ReactNode;
	rightIcon?: React.ReactNode;
	className?: string;
	dataqa?: string;
}

function Badge({
	value,
	type = 'neutral',
	badgeStyle = 'outline',
	size = 'standard',
	leftIcon,
	rightIcon,
	className,
	dataqa,
}: BadgeProps) {
	const badgeClassName = classnames(
		'common-ui-badge',
		badgeStyle,
		type,
		size,
		className
	);

	return (
		<div className={badgeClassName} {...(dataqa && { 'data-qa': dataqa })}>
			{leftIcon && <span className="badge-icon">{leftIcon}</span>}
			<span className="badge-text">{value}</span>
			{rightIcon && <span className="badge-icon">{rightIcon}</span>}
		</div>
	);
}

export default Badge;
